import {
  white,
  black,
  blue100,
  blue500,
  blue900,
  lightBlue900,
  greyA100,
  grey50,
  grey100,
  grey500,
  yellow100,
  green50,
} from './colors';

const colors = {
  light: white,
  dark: black,
  primary: blue900,
  secondary: blue100,
  secondaryText: lightBlue900,
  secondaryStroke: blue500,
  alternate: blue500,
  alternateText: lightBlue900,
  disabled: grey100,
  disabledText: grey500,
  shadow: greyA100,
  border: grey50,
  warning: yellow100,
  notification: yellow100,
  selection: green50,
  focus: blue100,
};

export default colors;
